import { Injector } from "@angular/core";
import { LayoutService } from "../app/shared/services/layout.service";
// src/app/shared/services/layout.service
var injector = Injector.create([
  { provide: LayoutService, deps: [] },
]);

var inject =injector.get(LayoutService)

var lang =inject.language

export const environment = {
  
  production: true,
  firebase: {
    apiKey: "Your Api Key",
    authDomain: "Your Auth Domain",
    databaseURL: "Your Database Url",
    projectId: "Your Project Id",
    storageBucket: "Your StorageBucket url",
    messagingSenderId: "Your Sender Id"
  },



  // Server_URL:'https://alnada-afdalsadqaapi-dev.azurewebsites.net/api/ar',  
  //   ServerImages_URL:`https://alnada-afdalsadqaapi-dev.azurewebsites.net/`
  
    //  Server_URL:`https://afdhalsadakaapi.wecancity.com/api/ar`,
    //  ServerImages_URL:`https://afdhalsadakaapi.wecancity.com`

// New APi
    
    Server_URL:`https://alnada-afdalsadqaapi.azurewebsites.net/api/ar`,
    ServerImages_URL:`https://alnada-afdalsadqaapi.azurewebsites.net`
 
};
 